import Vue from 'vue'
import Footer from './App.vue'
import { getJsonData } from '@/common/utils/dom'
import './main.entry.scss'

const init = () => {
  const mountEl = document.querySelector('#globalFooterApp')
  if (!mountEl) {
    return false
  }
  const GlobalFooter = Footer
  const applicationData = getJsonData('#applicationData') ?? undefined
  const productCategories = getJsonData('#applicationData').product_categories ?? undefined
  const jsonRootCategory = getJsonData('#json-root-category') || {}
  new Vue({
    render: h => h(GlobalFooter, {
      props: {
        productCategories,
        applicationData,
        jsonRootCategory
      }
    })
  }).$mount(mountEl)
}
init()
